/* eslint-disable @typescript-eslint/naming-convention */
import { useOutletContext } from "react-router-dom"
import { useComputed, useSignal } from "@preact/signals-react"

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

import { addRole } from '../../../../state/actions/roleActions'

import { assembleEntity, validateForm, validateInput } from "../../../../utils/form"
import { currentBusinessEntitySignal } from "../../../../state/signals/businessEntitySignals"

const AddRoleModal = function ({ showSignal, hideModal }) {

	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData } = useOutletContext()

	const disableSubmitSignal = useSignal(true)

	const submitAddRoleForm = async (event) => {
		event.preventDefault()
		const form = event.target.form
		if (!validateForm(form)) {
			throw Error("Invalid form data")
		}
		const role = assembleEntity(form)
		role.type = 2
		role.parentBusinessEntityId = currentBusinessEntitySignal.value.id //XXX TODO ember sets parentBusinessEntity to the current BE
		await addRole(role, config, accessToken)
		hideModal()
	}

	const roleNameChanged = (event) => {
		const input = event.target
		if (!validateInput(input)) {
			disableSubmitSignal.value = true
		}
		disableSubmitSignal.value = false
	}

	return (
		<Modal show={showSignal.value} onHide={hideModal}>
			<Modal.Header closeButton>
				<Modal.Title>Add New Role</Modal.Title>
			</Modal.Header>
			<Form className="form-horizontal" spellCheck="false" autoComplete="off" autoCapitalize="off" autoCorrect="off">
				<Modal.Body>
					<Form.Group>
						<label className="col-md-2 control-label">Name</label>
						<div className="col-md-10">
							<input type='text' id='newRoleName' className='form-control' autoFocus="autofocus" maxLength="50" name="name" onChange={roleNameChanged} />
						</div>
					</Form.Group>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={hideModal}>Cancel</Button>
					<Button onSubmit={submitAddRoleForm} disabled={disableSubmitSignal.value}>Add</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	)
}
export default AddRoleModal